<template>
  <div>
    <b-modal id="modal-input-capem" size="lg" centered title="Tambah Data Capem" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <b-form-group label="Nama Capem" label-cols-md="3">
          <b-form-input autofocus type="text" :state="checkIfValid('namaCapem')" v-model="$v.data.namaCapem.$model"></b-form-input>
        </b-form-group>
        <b-form-group label="Kode Capem" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('kodeCapem')" v-model="$v.data.kodeCapem.$model"></b-form-input>
        </b-form-group>
        <b-form-group label="Nama Mitra" label-cols-md="3">
          <multiselect
            v-model="$v.data.mitra.$model"
            :state="checkIfValid('mitra')"
            :options="mitra"
            @input="getKoordinator(data.mitra), (data.koordinator = null), (data.cabang = null)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Nama Koordinator" label-cols-md="3">
          <multiselect
            v-model="$v.data.koordinator.$model"
            :state="checkIfValid('koordinator')"
            :options="koordinator"
            @input="getCabang(data.koordinator), (data.cabang = null)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKoordinator"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Nama Cabang" label-cols-md="3">
          <multiselect
            v-model="$v.data.cabang.$model"
            :state="checkIfValid('cabang')"
            :options="cabang"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCabang"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Provinsi" label-cols-md="3">
          <multiselect
            v-model="$v.data.provinsi.$model"
            :state="checkIfValid('provinsi')"
            :options="provinsi"
            @input="getKota(data.provinsi)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            label="namaProvinsi"
            track-by="id"
            placeholder="-- Pilih Provinsi --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Kota" label-cols-md="3">
          <multiselect
            v-model="$v.data.kota.$model"
            :state="checkIfValid('kota')"
            :options="kota"
            @input="getKecamatan(data.kota)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKota"
            track-by="idKota"
            placeholder="-- Pilih Kabupaten/Kota --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Kecamatan" label-cols-md="3">
          <multiselect
            v-model="$v.data.kecamatan.$model"
            :state="checkIfValid('kecamatan')"
            :options="kec"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKecamatan"
            track-by="kecamatanId"
            placeholder="-- Pilih Kecamatan --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Alamat" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('alamatCapem')" v-model="$v.data.alamatCapem.$model"></b-form-input>
        </b-form-group>
        <b-form-group label="No. Telp" label-cols-md="3">
          <b-form-input type="number" :state="checkIfValid('noHpKantor')" v-model="$v.data.noHpKantor.$model"></b-form-input>
        </b-form-group>
        <b-form-group label="Latitude" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('latitude')" v-model="$v.data.latitude.$model"></b-form-input>
        </b-form-group>
        <b-form-group label="Longtitude" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('longitude')" v-model="$v.data.longitude.$model"></b-form-input>
        </b-form-group>
      </b-form>
      <!-- <img :src="src1" /> -->
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input-capem')"> Tutup </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["mitra", "provinsi"],
  data() {
    return {
      data: {
        namaCapem: "",
        kodeCapem: "",
        mitra: "",
        provinsi: "",
        cabang: "",
        koordinator: "",
        kota: "",
        kecamatan: "",
        alamatCapem: "",
        noHpKantor: "",
        longitude: 0,
        latitude: 0,
      },
      kota: [],
      kec: [],
      koordinator: [],
      cabang: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
    mitra_aktif() {
      return this.$store.state.mitra_aktif;
    },
    koordinator_aktif() {
      return this.$store.state.koordinator_aktif;
    },
    cabang_aktif() {
      return this.$store.state.cabang_aktif;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      mitra: {
        required,
      },
      cabang: {
        required,
      },
      koordinator: {
        required,
      },
      provinsi: {
        required,
      },
      kota: {
        required,
      },
      kecamatan: {
        required,
      },
      namaCapem: {
        required,
      },
      kodeCapem: {
        required,
      },
      alamatCapem: {
        required,
      },
      noHpKantor: {
        required,
      },
      longitude: {
        required,
      },
      latitude: {
        required,
      },
    },
  },
  watch: {
    mitra_aktif(newVar, oldVar) {
      if (newVar != oldVar) {
        this.data.mitra = newVar;
      }
    },
    koordinator_aktif(newVar, oldVar) {
      if (newVar != oldVar) {
        this.data.koordinator = newVar;
      }
    },
    cabang_aktif(newVar, oldVar) {
      if (newVar != oldVar) {
        this.data.cabang = newVar;
      }
    },
  },
  async mounted() {
    this.data.mitra = this.mitra_aktif;
    this.data.koordinator = this.koordinator_aktif;
    this.data.cabang = this.cabang_aktif;
    await this.getKoordinator(this.data.mitra);
    await this.getCabang(this.data.cabang);
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async getKota(x) {
      if (x) {
        let kota = await this.$axios.get("kota/listByProvinsiId/" + x.id);
        // console.log(kota.data.data);
        this.kota = kota.data.data;
      }
    },
    async getKoordinator(x) {
      if (x) {
        let koordinator = await this.$axios.get("koordinator/listKoordinatorByMitraId/" + x.id);
        //   console.log(koordinator.data.data, "ini koordinator");
        this.koordinator = koordinator.data.data;
      }
    },
    async getCabang(x) {
      if (x) {
        let cabang = await this.$axios.get("cabang/listCabangByKoordinatorId/" + x.id);
        // console.log('listCabang capem', cabang);
        this.cabang = cabang.data.data;
      }
    },
    async getKecamatan(x) {
      if (x) {
        let kec = await this.$axios.get("kecamatan/listByKotaId/" + x.idKota);
        // console.log(kec.data.data);
        this.kec = kec.data.data;
      }
    },
    simpan() {
      let vm = this;
      vm.data.provinsiId = vm.data.provinsi.id;
      vm.data.mitraId = vm.data.mitra.id;
      vm.data.koordinatorId = vm.data.koordinator.id;
      vm.data.cabangId = vm.data.cabang.id;
      vm.data.kotaId = vm.data.kota.idKota;
      vm.data.kecamatanId = vm.data.kecamatan.kecamatanId;
      vm.$axios
        .post("capem/register", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN CAPEM",
              showing: true,
            });
            this.data.namaCapem = "";
            this.data.kodeCapem = "";
            this.data.alamatCapem = "";
            this.data.noHpKantor = "";
            this.$v.$reset();
            this.$bvModal.hide("modal-input-capem");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: _.toUpper(res.data.message),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
